module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGDRINSECT-912b29673128a7d1cbb1295aa0f6aa3a.png";